export default {
	sec_01: {
		title: {
			one: 'JP WORLD Pay ',
			two: 'カード',
		},
		desc: {
			one: 'デビットカードとプリペイドカードでJPWORLDPAYにアクセスしたり、',
			two: 'クレジット利用で日常的な購入に簡単に資金を',
			three: '調達できます。',
		},
	},
	sec_08: {
		title: 'JP WORLD Pay ·クレジット',
		one: {
			desc: {
				one: 'その場で商品を購入して、時間の経過とともにお支払い。',
				two: 'JP WORLD Payを利用できる全ての加盟店で',
				three: '1万円以上購入するとき、特別金融を受けてください。',
			},
			btn: 'JP WORLD Payクレジットについて学ぶ',
		},
		two: {
			desc: {
				one: '1万円相当の商品を購入する度に6ヶ月以内に',
				two: '全額を支払う場合は利息はありません。',
				three: '6ヶ月以内に残金を支払わない場合は、',
				four: '購入日から利息がお客様のアカウントに請求されます。',
				five: '最低月額支払いが必要となります。クレジット承認の対象です。',
			},
			btn: '利用規約を見る',
		},
	},
	sec_03: {
		one: {
			title: {
				one: 'NEW',
				two: 'JP WORLD Pay',
				three: 'キャッシュバック(JPYSコイン)',
			},
			desc: {
				one: 'JP WORLD Pay 購入時に無制限の3%キャッシュバック、',
				two: '他の全て商品の購入時に無制限の2%を獲得します。',
				three: 'いつ使用できるかを最初に確認してください。',
				four: '既に2%キャッシュバックを受け取った方はリストに登録する必要ありません。',
				five: '自動的にアップグレードされます。',
			},
			btn: 'Learn about JP WORLD Pay Credits',
		},
		two: {
			title: {
				one: 'JP WORLD Pay',
				two: 'キャッシュカード',
			},
			desc: {
				one: 'JP WORLD Pay残高につながれているデビットカードで',
				two: '資金にアクセスして',
				three: '資金を簡単に管理することができます。',
			},
			btn: 'JP WORLD Payキャッシュカードの詳細',
		},
	},
	common: {
		coming_soon: '準備中です。',
	},
};
